import React from 'react';

import BaseModal from '@/components/BaseModal.js';

import './ImagePreviewModal.scss';

const ImagePreviewModal = ({
  alt = '',
  onClose,
  show = false,
  src = '',
  title = '图片预览',
}) => (
  <BaseModal
    show={show}
    title={title}
    onClose={onClose}
    className="image-preview-modal"
    bodyClassName="image-preview-modal__body"
    maxWidth="min(1120px, calc(100vw - 32px))"
  >
    {show && src ? (
      <img
        className="image-preview-modal__image"
        src={src}
        alt={alt || title}
        loading="eager"
      />
    ) : null}
  </BaseModal>
);

export default ImagePreviewModal;
